<template>
  <div class="row">
    <div :class="col">
      <label class="bold-600" v-if="label">
        {{ label }}
        <span v-if="required" class="required-input" :class="{'error-input' : $v.content.$error}">* </span>
      </label>
      <div class="rueden-input">
        <vue-simple-suggest @select="updateValue"
                            :list="setList"
                            :min-length="0"
                            :max-suggestions="0"
                            :filter-by-query="true">
          <input @change="updateValue"
                 class="form-control"
                 v-model="content"
                 type="text"
                 autocomplete="off"
                 :required="required"
                 :class="{'border border-danger' : $v.content.$error}"
          />
        </vue-simple-suggest>

      </div>
    </div>
  </div>
</template>
<script>

import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';
import General from '@/mixins/general';
import axios from "axios";
import {required} from "vuelidate/lib/validators";

export default {
  mixins: [General],
  components: {VueSimpleSuggest},
  props: {
    value: {
      Type: String,
      required: true
    },
    label: String,
    uri: String,
    list: Array,
    col: {
      Type: String,
      default: 'col-12 col-md-12'
    },
    required: {
      Type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      content: this.value,
      options: null
    }
  },
  validations() {
    let rules = { content: {} };
    if (this.required) {
      rules.content = {...rules.content, ...{ required }};
    }
    return rules;
  },
  mounted() {
    if (this.$v.content.$invalid) {
      this.changeErrorCount(true);
      // console.log("+1",(this.label ? this.label : this.placeholder) + " erstellt");
    }
  },
  methods: {
    updateValue(val) {
      this.$v.content.$touch();
      if (typeof val === 'string') this.content = val;
      this.$emit('input', this.content)
      this.sendGaEvent(this.label ? this.label : this.options.join('/'));
    },
    setList() {
      if (this.uri) {
        return axios.get(this.uri)
            .then(response => {
              this.options = response.data;
              return this.options;
            });
      } else {
        this.options = this.list;
        return this.options;
      }
    },
  },
  watch: {
    value: function (v) {
      this.content = v;
    },
    $global: function (newV) {
      if (newV.showAllInputError) {
        this.$v.content.$touch();
      }
    },
    '$v.content.$invalid': function (newV) {
      this.changeErrorCount(newV);
      // console.log(newV ? "+1" : "-1",(this.label ? this.label : this.placeholder) + " geändert");
    },
    content: function () {
      this.$v.content.$touch();
    }
  },
  destroyed() {
    if (this.$v.content.$invalid) {
      this.changeErrorCount(false);
      // console.log("-1",(this.label ? this.label : this.placeholder) + " destroyed");
    }
  }
}
</script>
